import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UnpaidUserModal.module.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export function UnPaidModal({ onClose }) {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const userToken = useSelector(state => state.user.token);
    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>
                <button className={styles.closeButton} onClick={onClose}>
                    &times;
                </button>
                <h2 className={styles.modalHeading}>{t('UnPaidModal.heading')}</h2>
                <p className={styles.modalDescription}>{t('UnPaidModal.description')}</p>
                <button className={styles.subscribeButton} onClick={() => navigate('/subscriptions')}>{t('UnPaidModal.subscribeButton')}</button>
                
                {!userToken && <p className={styles.signInText}>
                    {t('UnPaidModal.signInText')}
                    <span onClick={() => navigate('/login')} className={styles.signInLink}>{t('UnPaidModal.signInLink')}</span>
                </p>}

            </div>
        </div>
    );
}
